module.exports = __webpack_public_path__ + "static/anonine_main-b7ef41bcf8b77b379ac0582afa86dec9.jpg";